<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">Monitoring</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="AddMeasurerItemsForm">
              <div class="row">
                <!-- Item Name -->
                <div class="col-md-6">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Item Name" type="text" formControlName="ItemName">
                    <mat-error class="mt-2" *ngIf="fc.ItemName.invalid && (fc.ItemName.dirty || fc.ItemName.touched)">
                      Item Name is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Code -->
                <div class="col-md-6">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Code" type="text" formControlName="Code">
                    <mat-error class="mt-2" *ngIf="fc.Code.invalid && (fc.Code.dirty || fc.Code.touched)">
                      Code is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Item Type -->
                <div class="col-md-6 mt-3">
                  <div class="form-group">
                    <label>Item Type</label>
                    <ng-select class="form-control" [items]="ItemTypes" bindLabel="name" bindValue="id" formControlName="ItemType">
                    </ng-select>
                    <mat-error class="mt-2" *ngIf="fc.ItemType.invalid && (fc.ItemType.dirty || fc.ItemType.touched)">
                      Item Type is required
                    </mat-error>
                  </div>
                </div>

                <!-- Branch -->
                <div class="col-md-6 mt-3">
                  <div class="form-group">
                    <label>Branch</label>
                    <ng-select class="form-control" [items]="AllBranchs" bindLabel="name" bindValue="id" formControlName="Branch">
                    </ng-select>
                    <mat-error class="mt-2" *ngIf="fc.Branch.invalid && (fc.Branch.dirty || fc.Branch.touched)">
                      Branch is required
                    </mat-error>
                  </div>
                </div>

                <!-- IoT Device Checkbox -->
                <div class="col-md-12 mt-3">
                  <mat-checkbox [formControlName]="'isIot'" (change)="onIotChange($event)">
                    IoT Device
                  </mat-checkbox>
                </div>
                <!-- IoT Device Fields -->
                <ng-container *ngIf="AddMeasurerItemsForm.get('isIot').value">
                 
                  <!-- Device Nick Name -->
                  <div class="col-md-6 mt-3">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Device Nick Name" type="text" formControlName="DeviceNickName">
                      <mat-error class="mt-2" *ngIf="fc.DeviceNickName.invalid && (fc.DeviceNickName.dirty || fc.DeviceNickName.touched)">
                        Device Nick Name is required
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- Device ID -->
                  <div class="col-md-6 mt-3">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Device Id" type="text" formControlName="DeviceId">
                      <mat-error class="mt-2" *ngIf="fc.DeviceId.invalid && (fc.DeviceId.dirty || fc.DeviceId.touched)">
                        Device Id is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 mt-3">
                    <label>Monitoring Times</label>
                    <div class="form-group"
                    >
                    <ng-select   [ngModel]="selectedTimes"
                    (ngModelChange)="selectedTimes = $event"
                    [style.border]="fc.MonitoringTimes.touched ? (fc.MonitoringTimes.invalid ? '1px solid #dc3545 !important' : (fc.MonitoringTimes.valid && fc.MonitoringTimes.touched ? '1px solid #28a745' : 'none')) : 'none'"

                    [ngModelOptions]="{standalone: true}" formControlName="MonitoringTimes" multiple="true">
                    <ng-option  [disabled]="isTimeDisabled() && !selectedTimes.includes(date)" *ngFor="let date of Times" [value]="date"   
                  >{{date}}</ng-option>
                </ng-select>
                <mat-error class="mt-2 font11" *ngIf="fc.MonitoringTimes.invalid && (fc.MonitoringTimes.dirty || fc.MonitoringTimes.touched)">
                  Monitoring Times is required
                </mat-error>
                </div>
                
                  </div>

                  <!-- Emergency Phone Numbers -->
                <!-- Replace the emergency phone numbers section with this -->
<div class="col-md-12 mt-3">
  <label>Emergency Phone Numbers</label>
  <div formArrayName="EmergancyPhoneNumber">
    <div *ngFor="let phone of EmergancyPhoneNumber.controls; let i = index" class="phone-number-row">
      <mat-form-field class="example-full-width">
        <input matInput 
               [placeholder]="'Emergency Phone Number ' + (i + 1)" 
               [formControlName]="i"
               (input)="onPhoneInput($event, i)">
        <mat-error *ngIf="EmergancyPhoneNumber.controls[i].invalid && 
                         (EmergancyPhoneNumber.controls[i].dirty || 
                          EmergancyPhoneNumber.controls[i].touched)">
          Emergency Phone Number is required
        </mat-error>
      </mat-form-field>
      <button mat-icon-button 
              type="button"
              (click)="removePhoneNumber(i)" 
              *ngIf="EmergancyPhoneNumber.controls.length > 1">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
  <button mat-button (click)="addPhoneNumber()"  class="add-button">
    <mat-icon>add</mat-icon> Add Another Number
  </button>
</div>
                </ng-container>
              </div>

              <!-- Submit Buttons -->
              <div class="row mt-4">
                <div class="col-md-12">
                  <button mat-raised-button type="submit" 
                  *ngIf="!update" 
                  class="btn primary pull-right" 
                
                  (click)="addMeasurerItems()">
            Add
          </button>
                  <button mat-raised-button type="submit" *ngIf="update" class="btn primary pull-right" (click)="addMeasurerItems()"              
                  >
                    Save
                  </button>
                  <div class="clearfix"></div>
                </div>
              </div>
            </form>

            <!-- Data Table -->
            <br>
            <div class="table-responsive">
              <table mat-table [dataSource]="MeasurerItems" class="mat-elevation-z8 mt-3 table">
                <ng-container matColumnDef="ItemName">
                  <th mat-header-cell *matHeaderCellDef> Item Name </th>
                  <td mat-cell *matCellDef="let element"> {{element.ItemName}} </td>
                </ng-container>
                <ng-container matColumnDef="Code">
                  <th mat-header-cell *matHeaderCellDef> Code </th>
                  <td mat-cell *matCellDef="let element"> {{element.Code}} </td>
                </ng-container>
                <ng-container matColumnDef="ItemType">
                  <th mat-header-cell *matHeaderCellDef> Item Type </th>
                  <td mat-cell *matCellDef="let element"> {{getItemTypeName(element.ItemType)}} </td>
                </ng-container>
                <ng-container matColumnDef="Branch">
                  <th mat-header-cell *matHeaderCellDef> Branch </th>
                  <td mat-cell *matCellDef="let element"> {{getBranchName(element.Branch)}} </td>
                </ng-container>
                <ng-container matColumnDef="Action">
                  <th mat-header-cell *matHeaderCellDef> Action </th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-raised-button *ngIf="UserInfo.role == 'admin' || UserInfo.role == 'gm' || UserInfo.role == 'auditer'" (click)="Edit(element)">
                      <i class="material-icons">edit</i>
                    </button>
                    <button mat-raised-button *ngIf="UserInfo.role == 'admin' || UserInfo.role == 'gm' || UserInfo.role == 'auditer'" (click)="DeleteMeasurer(element)">
                      <i class="material-icons">delete</i>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>